import {
  CEC_LIST_ADD_NEW,
  CEC_LIST_ADD_NEW_SUCCESS,
  CEC_LIST_ADD_NEW_ERROR,
  CEC_LIST_DELETE,
  CEC_LIST_DELETE_ERROR,
  CEC_LIST_DELETE_SUCCESS,
  CEC_LIST_EDIT,
  CEC_LIST_EDIT_ERROR,
  CEC_LIST_EDIT_SUCCESS,
  CEC_LIST_GET_BY_ID,
  CEC_LIST_GET_BY_ID_ERROR,
  CEC_LIST_GET_BY_ID_SUCCESS,
  CEC_LIST_GET_LIST,
  CEC_LIST_GET_LIST_ERROR,
  CEC_LIST_GET_LIST_SUCCESS,
  CEC_LIST_ADD_NEW_REQUEST,
  CEC_LIST_FRONT_GET_BY_ID,
  CEC_LIST_SELECTED_ITEMS_CHANGE,
  CEC_LIST_BULK_DELETE,
  CEC_LIST_BULK_DELETE_SUCCESS,
  CEC_LIST_BULK_DELETE_ERROR,
} from '../actions';
// cecLists
const initialState = {
  cecLists: [],
  cecList: null,
  notifications: [],
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
  importSuccess: false,
  selectedItems: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CEC_LIST_SELECTED_ITEMS_CHANGE:
      return {
        ...state,
        loading: false,
        error: null,
        selectedItems: payload,
      };
    case CEC_LIST_FRONT_GET_BY_ID:
      return {
        ...state,
        loading: false,
        cecList: state.cecLists.find(e => e.id === payload),
      };
    case CEC_LIST_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case CEC_LIST_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        cecList: payload,
      };

    case CEC_LIST_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case CEC_LIST_GET_LIST:
      return {
        ...state,
        error: null,
        loading: true,
        importSuccess: false,
        deleteSuccess: false,
      };

    case CEC_LIST_GET_LIST_SUCCESS:
      return {
        ...state,
        cecLists: payload,
        loading: false,
        importSuccess: true,
      };
    case CEC_LIST_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case CEC_LIST_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: false,
        cecList: payload,
        cecLists: state.cecLists.concat(payload),
        addSuccess: true,
      };

    case CEC_LIST_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case CEC_LIST_EDIT_SUCCESS:
      return {
        ...state,
        cecLists: state.cecLists.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        cecList: payload,
        error: null,
        loading: false,
        editSuccess: true,
      };
    case CEC_LIST_DELETE:
    case CEC_LIST_BULK_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };
    case CEC_LIST_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        cecLists: state.cecLists.filter(c => c.id !== payload),
        deleteSuccess: true,
      };

    case CEC_LIST_BULK_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        cecLists: state.cecLists.filter(c => !payload.includes(c.id)),
        deleteSuccess: true,
      };

    case CEC_LIST_DELETE_ERROR:
    case CEC_LIST_ADD_NEW_ERROR:
    case CEC_LIST_EDIT_ERROR:
    case CEC_LIST_GET_BY_ID_ERROR:
    case CEC_LIST_GET_LIST_ERROR:
    case CEC_LIST_BULK_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
